window.Products.Accessory.LightweightFaceCovering = function() {};
window.Products.Accessory.LightweightFaceCovering.inherits(window.Products.Accessory.Accessory);
window.Products.Accessory.LightweightFaceCovering.id = 92;
window.Products.Accessory.LightweightFaceCovering.slug = 'lightweight-face-covering';
window.Products.Accessory.LightweightFaceCovering.has_3d = true;
window.Products.Accessory.LightweightFaceCovering.use_glb = true;
window.Products.Accessory.LightweightFaceCovering.dpi = 150;

window.Products.Accessory.LightweightFaceCovering.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.object.position.y = -0.1;

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.aoMapIntensity = 2;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
		}
		me.updateThreeTexture(modelViewer);
	});
};

window.Products.Accessory.LightweightFaceCovering.prototype.setThreeControls = function(controls) {
	controls.minDistance = 0.9;
	controls.maxDistance = 2.0;
};

window.Products.Accessory.LightweightFaceCovering.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[1].material.map = modelViewer.texture;
	modelViewer.object.children[1].material.map.flipY = false;
	modelViewer.object.children[1].material.needsUpdate = true;
};